<template>
  <p class="generic-info-message u-reset"><slot /></p>
</template>
